<template>
  <div v-for="(component, index) in content" :key="`${component.fields.component}-${index}`">
    <RenderContent :content="component.fields.content" />
  </div>
  <FindDealership />
  <AboutUs />
  <InstagramFeed />
</template>

<script setup lang="ts">
import FindDealership from "~/components/RenderContent/FindDealership/FindDealership.vue";
import AboutUs from "~/components/RenderContent/AboutUs/AboutUs.vue";
import InstagramFeed from "~/components/RenderContent/InstagramFeed/InstagramFeed.vue";

const { getContent, data: content } = useContent('home');

getContent();
</script>
